import React, { useState, useEffect } from 'react';
// import axios from 'axios';
import { 
    Button, 
    TextField, 
    Table, 
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TablePagination,
    Container,
    Autocomplete,
    Typography,
    Paper
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete'
import { userRequest } from '../../requestMethods';
import axios from 'axios';

function VocabularyEditor() {
  const [words, setWords] = useState([]);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [saving, setSaving] = useState(false);

  const [searchTerm, setSearchTerm] = useState('');
  const posOptions = ['', 'ADJ', 'ADP', 'ADV', 'AUX', 'CONJ', 'CCONJ', 'DET', 'INTJ', 'NOUN', 'NUM', 'PART', 'PHRASE', 'PRON', 'PROPN', 'PUNCT', 'SCONJ', 'SYM', 'VERB'];

  const [showPos, setShowPos] = useState(false)

  useEffect(() => {
    const fetchData = async () => {
      const result = await userRequest(
        `/word?page=${page}&pageSize=${pageSize}`,
      );
      setWords(result.data.words);
      setTotalPages(result.data.totalPages);
    };
    fetchData();
  }, [page, pageSize]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPageSize(parseInt(event.target.value, 10));
    setPage(0);
  };

  const onTextChange = (event, index) => {
    const { id, value } = event.target;
    if (id === "transcript" || id === "audioUrl") {      
      const newWords = [...words];
      newWords[index][id] = value;
      setWords(newWords);
    }
  }

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  }

  const searchWord = async () => {
    // make API call
    const response = await userRequest.get(`/word/search/${searchTerm}`);
    
    // console.log(response.data)
    if (response.data && response.data.words) {
        setWords(response.data.words); // update your state with the returned words
        setTotalPages(response.data.totalPages)
        setPage(response.data.currentPage)
    }
  }

  const handleFindTranscript = async (index) => {
    if (index > words.length) {
      alert('Something went wrong. Word index is not found. Returning.')
      console.log(index, words.length)
      return
    }

    let word = words[index]
    const response = await axios.post(`http://127.0.0.1:5000/word`, { text: word.word });
    if (response.data) {
        word.transcript = response.data.api
        words[index] = word
        setWords([...words])
    }
  };

  const makeTextToSpeech = async (event, index) => {
    if (index > words.length) {
      alert('Something went wrong. Word index is not found. Returning.')
      console.log(index, words.length)
      return
    }

    let word = words[index]
    const response = await userRequest.post('/nlp/generateSpeech', { text: word.word });
    if (response.data.status === 'success') {
      word.audioUrl = response.data.audioUrl;
      words[index] = word
      setWords([...words])
    }
  }
  
  const playAudio = (audioUrl) => {
    const audio = new Audio(audioUrl);
    audio.play();
  }

  const saveWord = async (event, index) => {

    if (index > words.length) {
      alert('Something went wrong. Word index is not found. Returning.')
      console.log(index, words.length)
      return
    }
    
    let word = words[index]
    console.log(word)
    let obj = { 
      transcript: word.transcript, 
      audioUrl: word.audioUrl
    }
    if (word.pos) {
      obj.pos = [...word.pos]
    }

    try {
      const response = await userRequest.put(`/word/${word._id}`, obj);
      if (response.data) {
        console.log(response.data)
      }
    } catch (error) {
      console.log(error)
    }

    setSaving(false)
  }

  const onPosTextChange = (event, index, posIndex) => {
    const { id, value } = event.target;
    console.log(id, value)
    const newWords = [...words];
    if (id === "pos_transcript" ) {
      newWords[index].pos[posIndex].transcript = value;
      setWords(newWords);
    }
    else if (id === "pos_audioUrl") {
      newWords[index].pos[posIndex].audioUrl = value;
      setWords(newWords);
    }
  };

  const onPosSpacyPosChange = async (index, posIndex, newValue) => {
    words[index].pos[posIndex].spacyPos = newValue
    setWords([...words])
  };

  return (
    <Container>
      <Typography variant="h4" component="h1" gutterBottom sx={{ mt: 3 }}>
        Vocabulary Editor
      </Typography>
      
      <Paper elevation={3} sx={{ p: 3, mb: 4 }}>
        <TextField
          id="search"
          label="Search"
          fullWidth
          value={searchTerm}
          onChange={handleSearchChange}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              searchWord();
            }
          }}
          sx={{ mb: 2 }}
        />
        <Button 
          variant="contained" 
          onClick={searchWord}
        >
          Search
        </Button>
      </Paper>
      
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Word</TableCell>
            <TableCell>Transcript</TableCell>
            <TableCell></TableCell>
            <TableCell>AudioURL</TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {words.map((word, index) => (
            <>
              <TableRow key={index}>
                <TableCell>
                  <TextField value={word.word} />
                  <Button 
                    variant='contained' 
                    onClick={() => {
                      if (!word.pos)
                        word.pos = []
                      word.pos.push({ spacyPos: '', transcript: '', audioUrl: '' })
                      words[index] = word
                      setWords([...words])
                    }}>
                      + POS
                  </Button>
                </TableCell>
                <TableCell>
                  <TextField id="transcript" value={word.transcript ? word.transcript : ''} onChange={(e) => onTextChange(e, index)} />
                </TableCell>
                <TableCell>
                  <Button variant='contained' onClick={(e) => handleFindTranscript(index)}>Find</Button>
                </TableCell>
                <TableCell>
                  {/* <TextField value={'https://englishvoca.s3.ap-northeast-2.amazonaws.com/output.mp3'} /> */}
                  <TextField id="audioUrl" value={word.audioUrl ? word.audioUrl : ''} onChange={(e) => onTextChange(e, index)} />
                </TableCell>
                <TableCell>
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={(e) => makeTextToSpeech(e, index)}
                    disabled={(word && word.audioUrl && word.audioUrl !== '' && word.audioUrl.length > 0)}>
                    Create audio
                  </Button>
                </TableCell>
                <TableCell>
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={() => playAudio(word.audioUrl)}
                    disabled={!(word && word.audioUrl && word.audioUrl !== '' && word.audioUrl.length > 0)}
                  >
                    Play
                  </Button>
                </TableCell>
                <TableCell>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={(e) => { setSaving(true); saveWord(e, index) }}
                    disabled={saving}>
                    Save
                  </Button>
                </TableCell>
              </TableRow>

              {/* { handle POS } */}
              {word.pos && word.pos.map((posData, posIndex) => (
                <TableRow sx={{backgroundColor: 'rgb(240,240,255)'}}>
                  <TableCell>
                    POS (point of speech) 
                    <Autocomplete
                      value={posData.spacyPos}
                      onChange={(event, newValue) => {
                        onPosSpacyPosChange(index, posIndex, newValue)
                        // console.log(newValue)
                      }}
                      options={posOptions}
                      renderInput={(params) => <TextField {...params} />}
                    />
                  </TableCell>
                  {/* <TableCell> */}
                    {/* <TextField
                      id="pos_spacyPos"
                      value={posData.spacyPos ? posData.spacyPos : ''}
                      onChange={(e) => }
                    />
                  </TableCell> */}
                  <TableCell>
                    <TextField
                      id="pos_transcript"
                      value={posData.transcript ? posData.transcript : ''}
                      onChange={(e) => onPosTextChange(e, index, posIndex)}
                    />
                  </TableCell>
                  <TableCell>
                  </TableCell>
                  <TableCell>
                    <TextField
                      id="pos_audioUrl"
                      value={posData.audioUrl ? posData.audioUrl : ''}
                      onChange={(e) => onPosTextChange(e, index, posIndex)}
                    />
                  </TableCell>
                  <TableCell>
                    <Button
                      variant="contained"
                      color="secondary"
                      onClick={() => playAudio(posData.audioUrl)}
                      disabled={!(posData.audioUrl && posData.audioUrl !== '' && posData.audioUrl.length > 0)}
                    >
                      Play
                    </Button>
                  </TableCell>
                  <TableCell>
                    <Button
                      variant="outlined"
                      onClick={() => {
                        if (posIndex < word.pos.length)
                          word.pos.splice(posIndex, 1)
                        words[index] = word
                        setWords([...words])
                      }}
                    >
                      <DeleteIcon/>
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </>
          ))}
        </TableBody>
      </Table>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={totalPages * pageSize}
          rowsPerPage={pageSize}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
    </Container>
  );
}

export default VocabularyEditor;
